import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type UpdateFilterSetV3 = OpalApi<'UpdateFilterSetV3', 200>

export const updateFilterSet: UpdateFilterSetV3 = async (args = {}) => {
  const filterSetId = args.params?.path.filter_set_id

  if (typeof filterSetId !== 'string') {
    throw new Error('Must supply a valid filter_set_id.')
  }

  const url = new URL(
    `/loupe/v3/filter_sets/${filterSetId}`,
    window.location.origin
  )

  return HttpClient()
    .patch(url.toString(), args.requestBody)
    .then((res) => res.data)
}
